import { ButtonColor, ButtonSize, ButtonVariant } from './buttons.constants';
import { IconSize } from '../icon/icon.constants';

/*
  Shared button styling maps used by both Button and IconButton. Keep every
  utility a complete literal string — Tailwind scans this file as text, so
  template-literal concatenation would not be detected.
*/

export const baseClass = [
  "inline-flex items-center justify-center shrink-0 cursor-pointer rounded-full text-[0.8125rem] leading-none font-semibold tracking-[0.1em] uppercase [font-family:'DM_Sans_Variable',system-ui,sans-serif] transition duration-200 ease-in-out",
  'not-disabled:focus-visible:[outline:2px_solid_currentColor] not-disabled:focus-visible:outline-offset-2',
  'disabled:cursor-default',
];

// Heights are fixed dimensions, hardcoded as rem (not from the spacing scale).
export const sizeClass: Record<ButtonSize, string> = {
  [ButtonSize.SM]: 'min-h-[2.75rem]', // 44px
  [ButtonSize.MD]: 'min-h-[2.75rem]', // 44px
  [ButtonSize.LG]: 'min-h-[3rem]', // 48px
};

// Glyph size paired to each button size (32→16, 40→20, 48→24), so the icon
// scales in step with the button and callers never pick a mismatched size.
export const iconSizeForButton: Record<ButtonSize, IconSize> = {
  [ButtonSize.SM]: IconSize.SM,
  [ButtonSize.MD]: IconSize.MD,
  [ButtonSize.LG]: IconSize.LG,
};

// Color per variant. The `text-*` utilities also color icon glyphs, which
// inherit `currentColor`.
export const colorClass: Record<ButtonVariant, Record<ButtonColor, string>> = {
  [ButtonVariant.FILLED]: {
    [ButtonColor.PRIMARY]:
      'bg-primary text-on-primary not-disabled:hover:bg-primary-hover not-disabled:active:bg-primary-active disabled:bg-primary-disabled',
    [ButtonColor.SECONDARY]:
      'bg-secondary text-on-secondary not-disabled:hover:bg-secondary-hover not-disabled:active:bg-secondary-active disabled:bg-secondary-disabled',
    [ButtonColor.ERROR]:
      'bg-error text-on-error not-disabled:hover:bg-error-hover not-disabled:active:bg-error-active disabled:bg-error-disabled',
  },
  [ButtonVariant.OUTLINED]: {
    [ButtonColor.PRIMARY]:
      'border border-primary text-primary not-disabled:hover:bg-primary/20 not-disabled:active:bg-primary/40 disabled:border-primary-disabled disabled:text-primary-disabled',
    [ButtonColor.SECONDARY]:
      'border-[1.5px] border-[rgba(7,11,31,0.45)] bg-white text-[#070B1F] not-disabled:hover:border-[#070B1F] not-disabled:active:bg-[#070B1F]/5 disabled:border-secondary-disabled disabled:text-secondary-disabled',
    [ButtonColor.ERROR]:
      'border border-error text-error not-disabled:hover:bg-error/20 not-disabled:active:bg-error/40 disabled:border-error-disabled disabled:text-error-disabled',
  },
  [ButtonVariant.TEXT]: {
    [ButtonColor.PRIMARY]:
      'text-primary not-disabled:hover:bg-primary/20 not-disabled:active:bg-primary/40 disabled:text-primary-disabled',
    [ButtonColor.SECONDARY]:
      'text-secondary not-disabled:hover:bg-secondary/20 not-disabled:active:bg-secondary/40 disabled:text-secondary-disabled',
    [ButtonColor.ERROR]:
      'text-error not-disabled:hover:bg-error/20 not-disabled:active:bg-error/40 disabled:text-error-disabled',
  },
};
